var React = require('react');

function ArrowTopRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.26659 8.9987L0.333252 8.06536L6.73325 1.66536H0.999919V0.332031H8.99992V8.33203H7.66659V2.5987L1.26659 8.9987Z","fill":"currentColor"}));
}

ArrowTopRightInline.defaultProps = {"width":"9","height":"9","viewBox":"0 0 9 9","fill":"none"};

module.exports = ArrowTopRightInline;

ArrowTopRightInline.default = ArrowTopRightInline;
